//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VueHorizontal from 'vue-horizontal'
// import { ToggleButton } from 'vue-js-toggle-button'
import structuredClone from '@ungap/structured-clone';

export default {
  name: 'betbuilder-markets',
  components: { VueHorizontal },
  data() {
    return {
      marketsOriginal: [],
      markets: [],
      categories: [],
      //selectedCategory: 'Popular',
      marketsLoading: true
    }
  },
  props: ['event', 'category'],
  watch: {
    category: function (newCategory, oldCategory) {
      this.selectCategory(newCategory)
    }
  },
  mounted() {
    this.fetchMarkets()
  },
  computed: {
    error() {
      return this.$store.state.betbuilder.error
    }
  },
  methods: {
    async selectCategory(category) {
      this.selectedCategory = category
      if (this.selectedCategory) {
        let markets = _.filter(this.marketsOriginal, (item) => {
          return _.has(item.categories, this.selectedCategory)
        })

        markets = _.sortBy(markets, (item) => {
          return _.get(item.categories, this.selectedCategory, 999)
        })
        this.markets = markets
      } else {
        this.markets = structuredClone(this.marketsOriginal)
      }
    },
    async fetchMarkets() {
      const response = await this.$api().$get('/v1/betbuilder/events/markets', { params: { event_id: this.event.id, bookmaker: this.$config.BOOKMAKER, lang: this.lang, country: this.country } })
      this.marketsOriginal = response.markets
      this.categories = response.categories
      this.selectCategory(this.selectedCategory)
      this.$emit('set-categories', this.categories)
      this.marketsLoading = false
    },
    async openSettings() {
      this.$modal.show('modal-settings')
    }
  }
}
